import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import userIsLoggedInSelector from './user_is_logged_in_selector'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import entityTypes from 'helpers/enums/entityTypes'
import { makeLibraryURL } from 'helpers/urlHandler'

const getLesson = (state, props) => {
	if (props.entityUID) {
		return state.lessons[props.entityUID]
	}
	return null
}

const getOnCart = (state, props) => state.cart.list.indexOf(props.entityUID) !== -1
const getAddingToCart = (state, props) => state.cart.adding.indexOf(props.entityUID) !== -1
const getRemovingFromCart = (state, props) => state.cart.removing.indexOf(props.entityUID) !== -1
const getFirstLessonFree = (state, props) => (props.entityUID in state.lessons) ? state.lessons[props.entityUID].data.isFirstUserLesson : false

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.PREVIEW_LESSON_SHOW_IN_MY_LIBRARY,
	featureFlagsTypes.PAYWALLS_PROJECT,
])

// TODO: Revisar y asegurarse de que se esta haciendo bien el momorize
const makeCartButtonDecoratorSelector = createSelector(

	[
		getLesson,
		getOnCart,
		getAddingToCart,
		getRemovingFromCart,
		userIsLoggedInSelector,
		getFirstLessonFree,
		featureFlagsSelector,
	],
	(lesson, onCart, addingtoCart, removingFromCart, isLoggedUser, firstLessonFree, featureFlags) => {

		let buttonText = ''
		let strikethroughText = ''
		let state = ''
		let free = ''
		let price = ''
		let libraryObjectType = ''
		let newLessonInBundle = false
		let folderIdInMyLibrary = 0
		let showInMyLibraryRedirectUrl = ''
		const shouldUseShowInMyLibraryRedirectUrl = featureFlags[featureFlagsTypes.PREVIEW_LESSON_SHOW_IN_MY_LIBRARY]
		const hasPaywallProjectFF = featureFlags[featureFlagsTypes.PAYWALLS_PROJECT]
		if (lesson) {
			libraryObjectType = lesson.library_object_type
			free = lesson.data.free || lesson.data.isAyce
			state = lesson.data.state
			price = lesson.data.finalPrice
			if ((!isLoggedUser || (firstLessonFree && !addingtoCart && !onCart)) && lesson.library_object_type === entityTypes.LESSON) {
				buttonText = !hasPaywallProjectFF ? localize('global_save') : localize('cart_button_decorator_cartButtonText_add_to_my_library')
			} else if (state === 1) {
				newLessonInBundle = (libraryObjectType === entityTypes.BUNDLE && lesson.data.isNew === '1' && lesson.data.newLessonsAdded) ? true : false
				if (newLessonInBundle) {
					buttonText = localize('cart_button_decorator_cartButtonText_preview')
				} else {
					folderIdInMyLibrary = lesson.data.folderId
					buttonText = localize('cart_button_decorator_cartButtonText_show_in_my_library')
					if (shouldUseShowInMyLibraryRedirectUrl) {
						showInMyLibraryRedirectUrl = makeLibraryURL({}, lesson.data.folderIdInMyLibrary)
					}
				}
			} else {
				if (free) {
					if (addingtoCart) {
						buttonText = localize('cart_button_decorator_cartButtonText_adding')
					} else {
						buttonText = localize('cart_button_decorator_cartButtonText_add_to_my_library')
					}
				} else {
					if (addingtoCart) {
						buttonText = localize('cart_button_decorator_cartButtonText_adding_to_cart')
					} else if (removingFromCart) {
						buttonText = localize('cart_button_decorator_cartButtonText_removing_from_cart')
					} else if (onCart) {
						buttonText = localize('cart_button_decorator_cartButtonText_remove_from_cart')
					} else {
						if (price === '0.00') {
							buttonText = 'Add for free'
						} else {
							if (lesson.data.priceOriginal) {
								buttonText = '$' + price
							} else {
								buttonText = localize('cart_button_decorator_cartButtonText_purchase_for')+price
							}
						}
						if (lesson.data.priceOriginal) {
							strikethroughText = '$' + lesson.data.priceOriginal
						}
					}
				}
			}
		}

		return {
			loaded: lesson?true:false,
			friendlyUrl: lesson?lesson.data.friendlyUrl:'',
			free,
			strikethrough_text: strikethroughText,
			button_text: buttonText,
			state,
			library_object_type: libraryObjectType,
			onCart,
			addingtoCart,
			removingFromCart,
			isLoggedUser,
			newLessonInBundle,
			firstLessonFree,
			folderIdInMyLibrary,
			showInMyLibraryRedirectUrl,
			shouldUseShowInMyLibraryRedirectUrl,
		}
	}
)

export default makeCartButtonDecoratorSelector
